import HTML from "../../../assets/logo/HTML.svg";
import CSS from "../../../assets/logo/CSS.svg";
import javascript from "../../../assets/logo/javascript.svg";
import React from "../../../assets/logo/React.svg";
import nextjs from "../../../assets/logo/nextjs.svg";
import tailwindcss from "../../../assets/logo/tailwindcss.svg";
import jquery from "../../../assets/logo/jquery.svg";
import nodejs from "../../../assets/logo/nodejs.svg";
import bootstrap from "../../../assets/logo/bootstrap.svg";
import Sass from "../../../assets/logo/Sass.svg";
import figma from "../../../assets/logo/figma.svg";
import firebase from "../../../assets/logo/firebase.svg";
import php from "../../../assets/logo/php.svg";
import MySQL from "../../../assets/logo/MySQL.svg";
import docker from "../../../assets/logo/docker.svg";
import jenkins from "../../../assets/logo/jenkins.png";
import mongodb from "../../../assets/logo/mongodb.svg";
import postgresql from "../../../assets/logo/postgresql.svg";
import prisma from "../../../assets/logo/prisma.svg";
import redux from "../../../assets/logo/redux.svg";
import { useState } from "react";

export const Skills = () => {
	const logos = [
		{ src: HTML, alt: "HTML logo" },
		{ src: CSS, alt: "CSS logo" },
		{ src: javascript, alt: "javascript logo" },
		{ src: React, alt: "React logo" },
		{ src: nextjs, alt: "nextjs logo" },
		{ src: tailwindcss, alt: "tailwindcss logo" },
		{ src: jquery, alt: "jquery logo" },
		{ src: nodejs, alt: "nodejs logo" },
		{ src: bootstrap, alt: "bootstrap logo" },
		{ src: Sass, alt: "Sass logo" },
		{ src: figma, alt: "figma logo" },
		{ src: firebase, alt: "firebase logo" },
		{ src: MySQL, alt: "MySQL logo" },
		{ src: php, alt: "php logo" },
		{ src: docker, alt: "docker logo" },
		{ src: jenkins, alt: "jenkins logo" },
		{ src: mongodb, alt: "mongodb logo" },
		{ src: postgresql, alt: "MySQL logo" },
		{ src: prisma, alt: "prisma logo" },
		{ src: redux, alt: "redux logo" },
	];

	const [showSkills, setShowSkills] = useState(false);

	return (
		<section className="relative z-[2] flex flex-col gap-3 shadow dark:shadow-[0_1px_3px_0px_rgba(44,44,44,1)] flex justify-center pt-8 pb-0 md:py-7 overflow-x-scroll overflow-y-clip">
			{/* <div
        className={`${
          showSkills ? "h-auto" : "max-h-12 overflow-scroll"
        } px-8 xl:px-0 flex flex-wrap justify-center gap-[48px] lg:h-auto`}
      >
        {logos.map((logo, index) => (
          <img src={logo.src} alt={logo.alt} key={index} />
        ))}
      </div> */}
			<div
				className={`${
					showSkills ? "h-auto" : "max-h-12 pb-3"
				} px-3 md:px-8 xl:px-0 flex overflow-y-clip scrollbar-hidden lg:overflow-visible flex-wrap md:flex-nowrap justify-center gap-8 md:gap-[48px]`}>
				{logos.map((logo, index) => (
					<img
						src={logo.src}
						alt={logo.alt}
						key={index}
						className="size-8 lg:size-12 object-contain" // Adjust size as needed
					/>
				))}
			</div>
			<div
				onClick={() => setShowSkills(!showSkills)}
				className="md:hidden relative bg-slate-100 hover:bg-slate-150 duration-100 -bottom-0 shadow inset-x-0 flex flex-col justify-center items-center cursor-pointer">
				{showSkills ? "Less" : "More"}
				{showSkills ? (
					<svg
						className="w-4 h-4 text-gray-800"
						aria-hidden="true"
						xmlns="http://www.w3.org/2000/svg"
						width="24"
						height="24"
						fill="none"
						viewBox="0 0 24 24">
						<path
							stroke="currentColor"
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth="2"
							d="m5 15 7-7 7 7"
						/>
					</svg>
				) : (
					<svg
						className="w-4 h-4 text-gray-800"
						aria-hidden="true"
						xmlns="http://www.w3.org/2000/svg"
						width="24"
						height="24"
						fill="none"
						viewBox="0 0 24 24">
						<path
							stroke="currentColor"
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth="2"
							d="m19 9-7 7-7-7"
						/>
					</svg>
				)}
			</div>
		</section>
	);
};
